export default __webpack_public_path__ + "static/media/2h.5af98efa.png";